import React from 'react'
import { Column } from '@morningtrain/react-columns'
import { DenominationCurrency as DenominationCurrencyDisplay } from 'support/displays'

function DenominationCurrency (props) {
  return <Column {...props} />
}

DenominationCurrency.defaultProps = {
  ...Column.defaultProps,
  display: DenominationCurrencyDisplay
}

DenominationCurrency.propTypes = {
  ...Column.propTypes
}

export default DenominationCurrency
